import { bostaHttp } from 'http.js';

export const fetchTeamMembersList = (businessId, payload) => {
  return bostaHttp.get(`/sllr/businesses/${businessId}/users`, payload);
};

export const createNewMember = (businessId, payload) => {
  return bostaHttp.post(`/sllr/businesses/${businessId}/invite`, payload);
};

export const deletedMember = (id) => {
  return bostaHttp.delete(`/sllr/users/business/admin/${id}`);
};

export const suspendMember = (id) => {
  return bostaHttp.post(`/sllr/users/business/admin/${id}/suspend`);
};

export const reactivateMember = (id) => {
  return bostaHttp.post(`/sllr/users/business/admin/${id}/re-activate`);
};

export const reInviteMember = (businessId, userId) => {
  return bostaHttp.get(`/sllr/businesses/${businessId}/re-invite/${userId}`);
};

export const getUserPermission = (userId) => {
  return bostaHttp.get(`/sllr/users/${userId}`);
};

export const updateMember = (businessId, payload) => {
  return bostaHttp.put(`/sllr/businesses/${businessId}/users`, payload);
};

export const acceptInvitation = (payload) => {
  return bostaHttp.post(`/sllr/users/accept-invitation`, payload);
};

export const resendCode = (payload) => {
  return bostaHttp.post(`/sllr/users/business-admin/phone/verify`, payload);
};

export const verifyCode = (payload) => {
  return bostaHttp.post(`/sllr/users/business-admin/phone/confirm`, payload);
};

export const verifyAcceptInvitation = (payload) => {
  return bostaHttp.get(`/sllr/users/accept-invitation`, payload);
};
